export default "__VITE_ASSET__DfdUoOnt__"